import { financialCalendarRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const financialCalendarRoute: RouteObject = {
  path: financialCalendarRoutePaths.financialCalendar.path,
  async lazy() {
    const Page = await import('@/pages/financial-calendar');
    return { Component: Page.default };
  },
};

export const financialCalendarDayRoute: RouteObject = {
  path: financialCalendarRoutePaths.financialCalendarDay.path,
  async lazy() {
    const Page = await import('@/pages/financial-calendar/DayPage');
    return { Component: Page.default };
  },
};
